import { SxProps } from '@mui/material';

/** Largura dos blocos do formulário em relação ao container da página. */
export const RESOLVER_PENDENCIA_BLOCK_WIDTH = '60%';

export const sxResolverPage: SxProps = {  width: '100%',
  minWidth: 0,
  alignSelf: 'flex-start',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  boxSizing: 'border-box',
};

export const sxResolverMensagemCard: SxProps = {
  width: RESOLVER_PENDENCIA_BLOCK_WIDTH,
  maxWidth: '100%',
  boxSizing: 'border-box',  padding: '24px',
  marginBottom: '24px',
  borderRadius: '8px',
  backgroundColor: '#ffffff',
  boxShadow: 'none',
};

/** Altura do campo de justificativa no Figma (Resolver pendência). */
export const RESOLVER_PENDENCIA_JUSTIFICATIVA_HEIGHT = 180;

export const sxResolverJustificativaSection: SxProps = {
  marginTop: '24px',
  width: RESOLVER_PENDENCIA_BLOCK_WIDTH,
  maxWidth: '100%',
  boxSizing: 'border-box',
};

export const sxResolverJustificativa: SxProps = {
  width: '100%',
  minWidth: 0,  '& .MuiOutlinedInput-root': {
    alignItems: 'flex-start',
    height: 'auto !important',
    minHeight: `${RESOLVER_PENDENCIA_JUSTIFICATIVA_HEIGHT}px`,
    borderRadius: '8px',
    fontFamily: 'Unimed-Sans',
    backgroundColor: '#ffffff',
    position: 'relative',
  },
  '& .MuiOutlinedInput-input': {
    fontFamily: 'Unimed-Sans',
    color: '#383838',
    fontSize: '14px',
    lineHeight: '21px',
    paddingBottom: '32px',
    overflowY: 'auto',
  },
  '& .MuiInputAdornment-root': {
    position: 'absolute',
    bottom: 12,
    right: 12,
    height: 'auto',
    maxHeight: 'unset',
    alignSelf: 'unset',
    margin: 0,
  },
};

export const sxResolverConcluirButton: SxProps = {
  width: 'auto',
  alignSelf: 'flex-start',
  '@media (max-width: 799px)': {
    width: 'auto',
  },
};
